module.exports = __webpack_public_path__ + "static/Functional_Units-IAS1_s-01193d1d42ab8349c040e60b516aa4a5.png";